'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M14 10H2v2h12v-2zm0-4H2v2h12V6zm4 8v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zM2 16h8v-2H2v2z' });

var PlaylistAdd = function PlaylistAdd(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

PlaylistAdd = (0, _pure2.default)(PlaylistAdd);
PlaylistAdd.muiName = 'SvgIcon';

exports.default = PlaylistAdd;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/PlaylistAdd.js
// module id = 2728
// module chunks = 0